import QualityHubTaskDetails from './QualityHubTaskDetails';

import "./QualityHubTaskDetails.scss";

export * from './QualityHubTaskDetails.types';

export { QualityHubTaskDetails };

